import { useEffect, useState } from "react";
import { ArrowRight, Phone } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";

const WHATSAPP_URL =
  "https://wa.me/48512929641?text=" +
  encodeURIComponent("Dzień dobry, mam pytanie o dzierżawę nieruchomości pod maszt BTS.");

export default function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const hero = document.getElementById("hero");
      const contact = document.getElementById("kontakt");
      if (!hero) return;
      const heroBottom = hero.getBoundingClientRect().bottom;
      const contactTop = contact ? contact.getBoundingClientRect().top : Infinity;
      const viewportH = window.innerHeight;
      const past = heroBottom < 0;
      const beforeFooterCTA = contactTop > viewportH * 0.6;
      setVisible(past && beforeFooterCTA);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToForm = () => {
    document.getElementById("hero-form")?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 px-3 pb-3 pt-2 pointer-events-none transition-all duration-300 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
      }`}
      aria-hidden={!visible}
    >
      <div className="pointer-events-auto flex items-stretch gap-2 bg-white/80 backdrop-blur-md rounded-full p-1.5 shadow-2xl shadow-emerald-900/40 ring-1 ring-slate-200">
        <a
          href="tel:+48512929641"
          className="flex items-center justify-center w-12 h-12 bg-slate-900 hover:bg-slate-800 active:scale-95 text-white rounded-full transition-all flex-shrink-0 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
          aria-label="Zadzwoń do nas"
          tabIndex={visible ? 0 : -1}
        >
          <Phone className="w-5 h-5" aria-hidden="true" />
        </a>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-12 h-12 bg-[#25D366] hover:bg-[#1DA851] active:scale-95 text-white rounded-full transition-all flex-shrink-0 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
          aria-label="Napisz przez WhatsApp"
          tabIndex={visible ? 0 : -1}
        >
          <WhatsAppIcon className="w-5 h-5" />
        </a>
        <button
          type="button"
          onClick={scrollToForm}
          className="flex-1 bg-emerald-600 hover:bg-emerald-700 active:scale-[0.98] text-white font-semibold rounded-full transition-all flex items-center justify-center gap-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
          tabIndex={visible ? 0 : -1}
        >
          <span>Sprawdź potencjał</span>
          <ArrowRight className="w-4 h-4" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
